import { IResponse } from "../../services/interface/data";

export interface IPrompt {
    data: IResponse | undefined;
    handleSubmitPrompt: (value: string) => void;
    promptUIState: "closed" | "open" | "scrollable";
    setPromptUIState: (state: "closed" | "open" | "scrollable") => void;
}

export enum EPromptState {
    Initial = "initial" as any,
    Thinking = "thinking" as any,
    Success = "success" as any,
    Error = "error" as any,
    Collapsed = "collapsed" as any,
}
